import { oidcConfig } from "@/services/authConfig";
import { useNetworkStatus } from "./useNetworkStatus";

export function useOidcConfig() {
  const { isOnline } = useNetworkStatus();

  return {
    ...oidcConfig,
    automaticSilentRenew: isOnline,
  };
}
